<template>
  <ul class="leftMenu">
    <li
      v-for="(item,index) in currentMenu"
      :class="{ active:changedMenu === item.path}"
      @click="changeMenu(item,index)"
    >
      <span class="navItem clearfix">
        <i class="icon iconfont fl" :class="[{active:changedMenu === item.path},item.icon]"></i>
        <em class="fl">{{ item.name }}</em>
        <b
          v-show="item.children"
          class="icon iconfont icon-right1"
          :class="{active:showItem[index],leave:!showItem[index]}"
        ></b>
      </span>
      <transition name="fade">
        <ul v-if="item.children" class="item2" v-show="showItem[index]">
          <li
            v-for="item2 in item.children"
            :class="{ active:changedMenu === item2.path}"
            @click.stop="changeItem(item2)"
          >
            <span>
              <em>{{ item2.name }}</em>
            </span>
          </li>
        </ul>
      </transition>
    </li>
  </ul>
</template>

<script>
import { PLATFORMS } from '../util/constants';

export default {
  name: 'left-menu',
  props: {
    platform: { // 平台类型
      type: String,
      required: true,
      validate: val => PLATFORMS.indexOf(val) > -1
    },
    setActive: { // 设置当前菜单的选中样式
      type: Function,
      default: () => {}
    },
    defaultMenu: { // 登录成功后默认显示的菜单的path  /advertiser
      type: String,
      required: true
    },
    navMenus: { // 模拟接口返回的菜单的格式，等拿到接口后，直接替换就ok
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data () {
    return {
      changedMenu: '',
      currentMenu: [],
      showItem: Array.from({ length: 6 }, (v, k) => false)
    };
  },
  created () {
    this.changedMenu = this.defaultMenu;
    this.currentMenu = this.navMenus
  },
  methods: {
    getMenu () {
      this.$store.dispatch('getMenuList').then(() => {
        if (this.menuList.code === 1) {
          let list = this.menuList.list;
          for (let v2 in list) {
            let arr = this.navMenus.filter((v1) => {
              return v1.name === list[v2].title;
            });
            this.currentMenu.push(...arr);
          }
        }
      });
    },
    changeMenu (item, index) {
      if (item.path) {
        this.changedMenu = item.path;
        this.$router.push(item.path);
      }
      this.showItem = this.showItem.map(function (v, i) {
        return i === index ? !v : false;
      });
      if (item.children) {
        this.changedMenu = item.children[0].path;
        this.$router.push(item.children[0].path);
      }
    },
    changeItem (item) {
      this.changedMenu = item.path;
      this.$router.push(item.path);
    }
  },
  mounted () {
    this.navMenus.forEach((v, i) => {
      v.children && v.children.some(v2 => {
        return v2.path === this.changedMenu;
      }) && this.showItem.splice(i, 1, true);
    });
    this.changedMenu = this.setActive()
  },
  watch: {
    $route () {
      this.changedMenu = this.setActive()
    }
  }
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">
.leftMenu {
  position: fixed;
  top: 45px;
  left: 0;
  width: 200px;
  height: 100%;
  padding-top: 85px;
  font-size: 16px;
  color: #fff;
  background: #1d2b36;
  z-index: 10;
  li {
    position: relative;
    width: 100%;
    box-sizing: border-box;
    cursor: pointer;
    span {
      display: inline-block;
      width: 166px;
      padding: 14px 0 14px 30px;
      border-left: 4px solid transparent;
      i {
        font-size: 20px;
        height: 21px;
        /*line-height: 21px;*/
        margin-right: 15px;
        color: #becfe0;
      }
      .iconfont {
        color: #becfe0;
      }
    }
  }
  li.active {
    .navItem {
      border-left-color: #3dc1c4;
      background: #0f1a23;
    }
    i {
      color: #fff;
    }
  }
  .navItem:hover {
    border-left-color: #3dc1c4;
    background: #0f1a23;
    color: #fff;
    .iconfont {
      color: #fff;
    }
  }
  em {
    font-style: normal;
    height: 21px;
    line-height: 21px;
  }
  b {
    position: absolute;
    top: 19px;
    right: 18px;
    font-size: 12px;
  }
  b.active {
    transform: rotate(90deg);
    animation: rotate 0.3s;
    color: #fff;
  }
  @keyframes rotate {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(90deg);
    }
  }
  b.leave {
    transform: rotate(0deg);
    animation: rotateLeave 0.3s;
  }
  @keyframes rotateLeave {
    from {
      transform: rotate(90deg);
    }
    to {
      transform: rotate(0deg);
    }
  }
  .item2 {
    width: 100%;
    li {
      background: #0f1a23;
      span {
        display: inline-block;
        width: 126px;
        padding-left: 66px;
        font-size: 14px;
        color: #b5c3cb;
      }
    }
    li:hover,
    li.active {
      span {
        color: #fff;
        border-left-color: #3dc1c4;
      }
    }
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
}
</style>
